import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import { Link } from 'react-router';
import dateFormat from 'dateformat';

import { NetworkHelpers as Network } from '../../../../../../../helpers';

class SeriesSlider extends Component {

    render() {

        const settings = {
	        dots: false,
	        infinite: false,
	        speed: 500,
	        slidesToShow: 2,
	        slidesToScroll: 2,
	        initialSlide: 0,
	        responsive: [
		        {
			        breakpoint: 1200,
			        settings: {
				        slidesToShow: 3,
				        slidesToScroll: 3
			        }
		        },
		        {
			        breakpoint: 960,
			        settings: {
				        slidesToShow: 2,
				        slidesToScroll: 2,
				        initialSlide: 2
			        }
		        },
		        {
			        breakpoint: 600,
			        settings: {
				        slidesToShow: 1,
				        slidesToScroll: 1
			        }
		        }
	        ]
        };

        const { params, series } = this.props;

        return (
            <section className="row course-module-slider">
                <div className="col-centered col-xs-12 module-slider items-sliders">
                    <Slider { ...settings }>
                        { Object.keys( series ).map( ( s, index ) => {

                            const seriesPermissions = Network.getWebinarPermissions( series[ s ].id );

                            return (
                                <div className="item-slide background-image" key={ index }>
	                                <div className="text-box color-mask">
		                                <h6 className="h6 item-title white">{ series[ s ].name }</h6>
		                                <p className="p-tag item-date white">{ dateFormat( series[ s ].start_date, 'fullDate' ) }</p>
		                                <ul className="buttons-left pos-bottom">
											<li>
												<button type="button" className="btn btn-primary btn-block"
														data-toggle="modal" data-target="#addToBasket">
													<span className="icon">
														<i className="fa fa-shopping-cart fa-left"> </i>
													</span>
													<span className="label">Buy now<i className="fa fa-angle-right animated-right" /></span></button>
											</li>
		                                </ul>
	                                </div>
                                </div>
                            );
                        } ) }
                    </Slider>
                </div>
            </section>

        );

    }

}

SeriesSlider.propTypes = {
    params: PropTypes.object.isRequired,
    series: PropTypes.array.isRequired,
};

export default SeriesSlider;



// WEBPACK FOOTER //
// src/client/components/site/features/training/webinars/pages/elements/SeriesSlider.js